import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.less']
})
export class SidenavComponent implements OnInit {
  route: string;
 
  constructor(location: Location, router: Router) {
    // router.events.subscribe(val => { 
    //     this.route = location.path(); 
    //   console.log(this.route)
    // });
  }

  ngOnInit() {  
     this.route = window.location.pathname
    //  console.log(this.route)
  }
}
